import { render, staticRenderFns } from "./AboutTrajetoria.vue?vue&type=template&id=f3dad71c&scoped=true&"
import script from "./AboutTrajetoria.vue?vue&type=script&lang=js&"
export * from "./AboutTrajetoria.vue?vue&type=script&lang=js&"
import style0 from "./AboutTrajetoria.vue?vue&type=style&index=0&id=f3dad71c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3dad71c",
  null
  
)

export default component.exports